

export const ProjectBanner = ({ item }) => {

    return (
        <li >
            <div className="banner">
                SPONSORED
            </div>
        </li>
    )
} 
